import { createSchema } from 'morphism';

const collectionBaseSchema = {
  name: 'name',
  products: source => {
    return source.products.map(product => {
      return {
        id: product.merchantProductId || product?.id,
        name: product.name,
        images: product.images.map(image => {
          return {
            default: image.default,
            url: image.url
          };
        }),
        brand: product.brand,
        merchantProductId: product.merchantProductId,
        skus: product.skus.map(sku => {
          return {
            code: sku.code,
            price: sku.price
          };
        })
      };
    });
  }
};

const create = createSchema(collectionBaseSchema, { undefinedValues: { strip: true } });

const update = createSchema(collectionBaseSchema, { undefinedValues: { strip: true } });

export default {
  create: createSchema(create, { undefinedValues: { strip: true } }),
  update: createSchema(update, { undefinedValues: { strip: true } })
};
